import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, getUserNameToName, formatData } from '../../../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../../../utils/handleChangeHooks';
import { Breadcrumbs, Button, Input } from '../../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../../services/LinePickingService';
import ModalUploadRegistrations from './ModalUploadRegistrations';

const Insert = (props) => {
    const update = props.location?.state?.update;
    const type = props.location?.state?.registrationType;
    const showDescription = props.location?.state?.showDescription;
    const title = props.location?.state?.title;
    const icon = props.location?.state?.icon;
    const [openModal, setOpenModal] = useState(false);
    const [mappingRegistration, setMappingRegistration] = useState(update && props.mappingRegistration ? props.mappingRegistration : {
        code: undefined,
        description: undefined,
        mappingRegistrationTypeId: type,
    });

    const onChange = (event) => {
        onValueChange(event, mappingRegistration, setMappingRegistration);
    };

    const onConfirm = () => {
        if (validateInputsRequired("formMappinRegistration")) {
            if (update) {
                props.mappingRegistrationUpdate(mappingRegistration, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                props.mappingRegistrationInsert(mappingRegistration, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const titleMovementType = { icon: icon, label: title };
    const subtitlesMovementType = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }



    return (
        <div>
            <Breadcrumbs id="registrationInsert" title={titleMovementType} subtitles={subtitlesMovementType()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formMappinRegistration">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className='input-field no-padding  col s10'

                                    >
                                        <Input
                                            required
                                            id="code"
                                            name='code'
                                            placeholder={'Código'}
                                            type="text"
                                            defaultValue={mappingRegistration.code || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />

                                    </div>
                                    {showDescription &&
                                        <div
                                            className='input-field no-padding  col s10'
                                        >
                                            <Input
                                                required
                                                id="description"
                                                name='description'
                                                placeholder={'Descrição'}
                                                type="text"
                                                defaultValue={mappingRegistration.description || ''}
                                                onChange={onChange}
                                                maxLength="100"
                                            />
                                        </div>}
                                    <div className="input-field no-padding  col s1">
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => setOpenModal(true)}>
                                            <i className="Small material-icons">cloud_upload</i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {update &&
                                <div>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>{formatData(mappingRegistration?.updatedOn)}</span>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px' }}>{getUserNameToName(props?.usersFromElog, mappingRegistration?.updatedBy)}</span>
                                </div>
                            }
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>

                            <div className="row"></div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalUploadRegistrations
                open={openModal}
                id="ModalUploadRegistrations"
                registrationType={type}
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        mappingRegistration: state.linePickingReducer.mappingRegistration,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        mappingRegistrationInsert: (items, callback) => {
            dispatch(LinePickingService.createMappingRegistration(items, callback));
        },
        mappingRegistrationUpdate: (items, callback) => {
            dispatch(LinePickingService.updateMappingRegistration(items, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Insert)));
